import { fetch } from './fetch'
import { api } from '@/config'

const { API_APP_V2_URL, TEXT_PAGES_URL } = api

const getTextsBySlug = ({ params: { slug, ...rest } }) =>
  fetch({
    method: 'get',
    url: `${API_APP_V2_URL}${TEXT_PAGES_URL}/${slug}`,
    params: { ...rest }
  })

export const textsAPI = {
  getTextsBySlug
}
